export default {
    ListCve: "Tra cứu CVE",
    ListIP: "Tra cứu lỗ hổng"
};  
